const PROJECT_IMAGE_BASE_URL = 'https://assets.banjihagames.com/seoul2033editor/public/project_images';

const projectImageIdLists = [
  '0',
  '108',
  '11',
  '111',
  '112',
  '113',
  '114',
  '121',
  '133',
  '150',
  '151',
  '152',
  '17',
  '178',
  '186',
  '2',
  '20',
  '224',
  '225',
  '247',
  '266',
  '277',
  '3',
  '32',
  '43',
  '50',
  '62',
  '73',
  '75',
  '80',
  ' 82',
  '85',
  '86',
  '91',
  '95',
];

const projectImageList = projectImageIdLists.reduce((acc, id) => {
  acc.push({
    id,
    imageURL: `${PROJECT_IMAGE_BASE_URL}/${id}.png`,
  });

  return acc;
}, []);

export { PROJECT_IMAGE_BASE_URL, projectImageList };
